"use strict";
'use es6'; // UIComponents runs in some environments where window.navigator is undefined.
// See: https://git.hubteam.com/HubSpot/hubspot-book-builder/pull/88

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserAgent = exports.ignoresStyleTagInsertionOrder = exports.getEdgeVersion = exports.isSafari = exports.isFirefox = exports.isMS = exports.isEdge = exports.isIE11 = void 0;
var lowercasedUserAgent = window.navigator ? navigator.userAgent.toLowerCase() : '';

var isIE11 = function isIE11() {
  return lowercasedUserAgent.includes('trident/');
};

exports.isIE11 = isIE11;

var isEdge = function isEdge() {
  return lowercasedUserAgent.includes('edge/');
};

exports.isEdge = isEdge;

var isMS = function isMS() {
  return isIE11() || isEdge();
};

exports.isMS = isMS;

var isFirefox = function isFirefox() {
  return lowercasedUserAgent.includes('firefox');
};

exports.isFirefox = isFirefox;

var isSafari = function isSafari() {
  return lowercasedUserAgent.includes('safari/') && !lowercasedUserAgent.includes('chrome/') && !isEdge();
};

exports.isSafari = isSafari;

var getEdgeVersion = function getEdgeVersion() {
  var match = lowercasedUserAgent.match(/edge\/(\d+)/);
  return match ? +match[1] : undefined;
};

exports.getEdgeVersion = getEdgeVersion;

var ignoresStyleTagInsertionOrder = function ignoresStyleTagInsertionOrder() {
  return isIE11() || isEdge() && getEdgeVersion() < 17;
};
/**
 * For faking `navigator.userAgent` in tests.
 * @param {string} newUserAgent
 */


exports.ignoresStyleTagInsertionOrder = ignoresStyleTagInsertionOrder;

var setUserAgent = function setUserAgent(newUserAgent) {
  lowercasedUserAgent = newUserAgent.toLowerCase();
};

exports.setUserAgent = setUserAgent;